import React from "react";
//nodejs library to set properties for components
//import PropTypes from "prop-types";
//@material-ui/core components
//import { makeStyles } from "@material-ui/core/styles";
import "./styles/timeline.scss"
import { Link } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import { Hidden } from "@material-ui/core";

export default function TimeLine(props) {
  //const classes = useStyles();
  const { children, className, ...rest } = props;

//   console.log(props)
  return (
    <React.Fragment>

	<div class="container">
		<div id="timeline">

		{props.chapterList.map((item, index) => {
			return (
			<div className="timeline-item">
				<div className="timeline-icon">
					<img src={require("../../../static/images/catalog/cb.png")}></img>
				</div>
				<div className={`timeline-content` +  (index%2 === 0 ? "":" right")}>
					<h2>{item.lessonserial}</h2>
					
					<h3>{props.chapterList[0].local.target}</h3>
					<p>{item.intro[0]}</p>

					<h3>{props.chapterList[0].local.keypoint}</h3>

					<Grid container justify="center" alignContent="center">
						<Grid item xs={12} sm={8} md={8}>
							<div className="vCenter">
								<ul>
								{item.intro[1].split(";").map((item, index) => {
									return <li>{item}</li>
								})}
								</ul>
							</div>
						</Grid>
						
						<Grid item xs={4} sm={4} md={4}>
							<img src={require("../../../static/images/l1c1/cb-"+index+".png")}></img>
						</Grid>
						<Grid item xs={8} sm={12} md={12}>
							<Link to={`/lesson/${index+1}/chapter/1`}><a className="btn">{props.chapterList[0].info.start}</a></Link>
						</Grid>


					</Grid>
					<br/>
					
					
					
					
					
				</div>
			</div>
			)
			})
		}

			

			
		</div>
	</div>
    </React.Fragment>
  );
}
